import React, { useState } from "react"
import MultiSelect from "src/components/tailwind-components/MultiSelect"
import { useCreditContractPreparations } from "../hooks/useCreditContractPreparations"
import { CreditContractPreparationTable } from "./CreditContractPreparationTable"
import {
  CreditContractPreparationListProps,
  CreditContractPreparationStatus,
  CREDIT_CONTRACT_PREPARATION_STATUS_CONFIG,
} from "../types"

/**
 * クレジット契約準備作業一覧ページ。
 * ページネーションおよびステータスフィルタを管理する。
 */
export const CreditContractPreparationList: React.FC<CreditContractPreparationListProps> = ({
  defaultStatuses,
}) => {
  const [page, setPage] = useState<number>(1)
  const [statuses, setStatuses] = useState<CreditContractPreparationStatus[]>(defaultStatuses)

  // APIフックからデータを取得
  const { data, pagination, isLoading, error, refresh } = useCreditContractPreparations({
    statuses,
    page,
  })

  const handleStatusesChange = (selectedValues: string[]) => {
    setPage(1)
    setStatuses(selectedValues as CreditContractPreparationStatus[])
  }

  const handlePageChange = (nextPage: number) => {
    setPage(nextPage)
  }

  const handleStatusUpdate = async () => {
    await refresh()
  }

  // エラー処理
  if (error) {
    return (
      <div className="rounded-lg bg-white p-6 shadow-sm">
        <div className="py-12 text-center">
          <div className="mb-2 text-red-600">エラーが発生しました</div>
          <div className="text-sm text-gray-500">
            データの取得に失敗しました。プロダクトチームまでご連絡ください。
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="rounded-lg bg-white shadow-sm">
      {/* フィルタエリア */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-start gap-8">
          <div className="flex flex-col">
            <div className="text-[1.6rem] font-bold mb-2">作業ステータス</div>
            <div className="flex justify-start items-center gap-8 max-w-[600px]">
              <MultiSelect
                options={Object.entries(CREDIT_CONTRACT_PREPARATION_STATUS_CONFIG).map(
                  ([value, config]) => ({
                    value,
                    label: config.label,
                  })
                )}
                value={statuses}
                onChange={handleStatusesChange}
                placeholder="ステータスを選択"
              />
            </div>
          </div>
        </div>
      </div>

      {/* テーブルエリア */}
      <CreditContractPreparationTable
        data={data}
        pagination={pagination}
        isLoading={isLoading}
        onPageChange={handlePageChange}
        onStatusUpdate={handleStatusUpdate}
      />
    </div>
  )
}
